import React from 'react';

const PodWaybillsComponentLoadable = React.lazy(() => import('./PodWaybillsComponent'));

export {
    PodWaybillsComponentLoadable
}